import React from 'react';

import { Tooltip } from 'antd-v5';
import { MdInfo } from 'react-icons/md';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Text } from 'scouting-ui/lib';

import { RenewalStatus } from '@appTypes/enums';
import type { RosterScout } from '@modules/advancement/duck/types';
import { getIsDenChief } from '@modules/advancement/packRoster/utilsTyped';
import { isInactiveUnitSel } from '@modules/unit/duck/selectorsTyped';
import { ConditionalRender, Spin } from '@shared/components';

import styles from './Columns.scss';

export const RenewalStatusColumn: React.FC<{
  renewalStatus: string;
  record: RosterScout;
  areRenewalsLoading?: boolean;
  orgIsPack?: boolean;
}> = props => {
  const { areRenewalsLoading, record, renewalStatus, orgIsPack } = props;
  const { registrationId } = record;
  const isInactiveUnit = useSelector(isInactiveUnitSel);

  if (areRenewalsLoading && !registrationId) {
    return <Spin size="small" />;
  }

  const isDenChief = getIsDenChief(record);

  if (isDenChief && orgIsPack) {
    return <FormattedMessage id="shared.na" />;
  }

  if (isInactiveUnit) {
    return (
      <FormattedMessage id="advancement.PackRoster.column.renewalStatus.expiredUnit" />
    );
  }

  const showInfo =
    (renewalStatus === RenewalStatus.Expired ||
      renewalStatus === RenewalStatus.Eligible) &&
    !!record.bsaOrderId;

  return (
    <Text inline>
      {renewalStatus}{' '}
      <ConditionalRender value={showInfo}>
        <Tooltip
          title={
            <Text color="color-white" inline font="body-caption">
              <FormattedMessage id="advancement.PackRoster.column.renewalStatus.tooltip" />
            </Text>
          }
        >
          <MdInfo className={styles.infoIcon} />
        </Tooltip>
      </ConditionalRender>
    </Text>
  );
};
